if (!customElements.get('rudra-static-gallery')) {
  customElements.define(
    'rudra-static-gallery',
    class RudraStaticMediaGallery extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-rudra-static-gallery') || this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.viewer = this.querySelector('[id^="GalleryViewer"]');
        this.liveRegion = this.querySelector('[id^="GalleryStatus"]');

        this.querySelectorAll('[data-rudra-gallery-thumbnail]').forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => this.setActiveMedia(thumbnail.dataset.target, false));
        });
      }

      setActiveMedia(mediaId, prepend = false) {
        if (!this.viewer) return;

        const activeMedia =
          this.viewer.querySelector(`[data-media-id="${CSS.escape(mediaId)}"]`) ||
          this.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        this.viewer.querySelectorAll('[data-media-id]').forEach((panel) => {
          const isActive = panel === activeMedia;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', isActive);
        });

        this.querySelectorAll('[data-rudra-gallery-thumbnail]').forEach((thumbnail) => {
          thumbnail.setAttribute('aria-current', String(thumbnail.dataset.target === activeMedia.dataset.mediaId));
        });

        if (prepend && activeMedia !== this.viewer.firstElementChild) this.viewer.prepend(activeMedia);

        window.pauseAllMedia?.();
        activeMedia.querySelector('.deferred-media')?.loadContent?.(false);

        if (this.liveRegion) {
          const selectedThumbnail = this.querySelector(
            `[data-rudra-gallery-thumbnail][data-target="${CSS.escape(activeMedia.dataset.mediaId)}"]`
          );
          this.liveRegion.textContent = selectedThumbnail?.getAttribute('aria-label') || '';
        }
      }
    }
  );
}
